export default __webpack_public_path__ + "static/media/grey-arrow-down.b44a287d.svg";